import { featureToggles } from 'utils/featureToggles';
import type { PageNavigation } from 'navigation/types';

import * as urls from '../urls';

export const FOUNDATION_NAVIGATION: PageNavigation = {
  pageUrl: urls.getFoundationUrl(),
  currentLink: { text: 'Foundation', href: urls.getFoundationUrl() },
  links: [
    {
      text: 'Apply for Funding',
      href: urls.getFoundationApplicationUrl(),
    },
    {
      text: 'Funded Projects',
      href: urls.getFoundationProjectsUrl(),
    },
  ],
};

if (featureToggles.foundationDonations) {
  FOUNDATION_NAVIGATION.links.push({
    text: 'Donate',
    href: urls.getFoundationDonationUrl(),
  });
}
